export class Strings {
  private static readonly pattern: RegExp = new RegExp("'", "g");

  /**
   * 문자열이 비었는지  여부를 반환한다.
   * @param text 검사할 문자열
   * @return 문자열이 비었으면 True, 그렇지 않으면 False
   */
  static isEmpty(s: string): boolean {
    if (this.isNull(s) || !s || s.length == 0) return true;
    else return false;
  }

  /**
   * 좌우에 있는 white space를 제거한 문자열을 반환한다.
   * @param text 문자열
   * @return
   */
  static trim(text: string): string {
    if (this.isEmpty(text)) return text;

    let st: number = 0;
    let len: number = text.length;

    while (st < len && text.charAt(st) <= " ") st++;

    while (st < len && text.charAt(len - 1) <= " ") len--;

    return st > 0 || len < text.length ? text.substring(st, len) : text;
  }

  static lpad(text: string, size: number, char: string = ""): string {
    if (!text || size == 0 || text.length >= size) return text;

    let cnt: number = size - text.length;

    for (let i: number = 0; i < cnt; i++) text = char + text;

    return text;
  }

  /**
   * 문자열이 비어있으면 대신할 문자열을 반환한다.
   * @param text 검사할 문자열
   * @param reserved 검사할 문자열이 비었을때 대신할 문자열
   * @return 문자열이 비었으면 대신할 문자열이 반환되고, 그렇지 않으면 원본이 반환된다.
   */
  static ifEmpty(text: string, reserved: string): string {
    return this.isEmpty(text) ? reserved : text;
  }

  /**
   * 문자열이 null인지 판단하는 메소드
   * undefined => true
   * null => true
   * "null" => true
   * "아이몬" => false
   * "  " => false
   * @param text 검사할 문자열
   * @return 문자열이 undefined, null, "null"인경우 true 그렇지 않으면 false
   */
  static isNull(text: string): boolean {
    return text == undefined || text == null || "null".toUpperCase() == text.toUpperCase();
  }

  /**
   * 문자열이 비었거나 White space로 채워져있는지 여부를 반환한다.
   * @param text 검사할 문자열
   * @return 문자열이 비었거나 White space로 채워져있으면 True, 그렇지 않으면 False
   */
  static isBlank(text: string): boolean {
    return this.isEmpty(text) || this.trim(text).length == 0;
  }

  /**
   * 문자열이 비었거나 White space로 채워져있으면 대신할 문자열을 반환한다.
   * @param text 검사할 문자열
   * @param reserved 검사할 문자열이 비었을때 대신할 문자열
   * @return 문자열이 비었거나 White space로 채워져있으면 대신할 문자열이 반환되고, 그렇지 않으면 원본이 반환된다.
   */
  static ifBlank(text: string, reserved: string): string {
    return this.isBlank(text) ? reserved : text;
  }

  /**
   * 문자열에 작은따옴표가 들어 있는경우 `로 대체한다.
   *
   */
  static replaceSingleQuotes(text: string): string {
    return text.replace(this.pattern, "`");
  }
  /**
   * 개행문자가 \r\n 으로 되어 있는 경우에는 TextArea 에서 개행이 두번 되는 현상이 나타나는데
   * Flex 의 TextArea는 개행문자를 \r 로 처리하기 때문이다.
   * 이 메서드는 정규표현식을 이용해 전달된 문자열의 \n을 모두 제거한다.
   *
   * @param s
   * @return
   */
  static replaceNewLine(s: string): string {
    return s.replace(/\n/g, "");
  }

  /**
   * HTML태그가 포함한 문자열에서 HTML태그를 모두 제거 및 특정 태그를 허용한 나머지 태그를 제거한다.
   * 두 문자열 매개변수를 받아 html은 HTML태그를 포함한 문자열, tags는 허용할 태그를 comma로 구분한 문자열
   * 모든 태그를 제거시에는 html만 넣는다.
   * 예: html = 'Hellow<br><b>My name is</b>', tags = 'br,b'
   *
   * @param html
   * @param tags
   * @return
   */
  static stripHtmlTags(html: string, tags: string = ""): string {
    var tagsToBeKept: Array<string> = new Array();
    if (tags.length > 0) tagsToBeKept = tags.split(new RegExp("\\s*,\\s*"));

    var tagsToKeep: Array<string> = new Array();
    for (var i: number = 0; i < tagsToBeKept.length; i++) {
      if (tagsToBeKept[i] != null && tagsToBeKept[i] != "")
        tagsToKeep.push(tagsToBeKept[i]);
    }

    var toBeRemoved: Array<string> = new Array();
    var tagRegExp: RegExp = new RegExp("<([^>\\s]+)(\\s[^>]+)*>", "g");

    var foundedstrings: Array<string> = html.match(tagRegExp);
    for (i = 0; i < foundedstrings.length; i++) {
      var tagFlag: boolean = false;
      if (tagsToKeep != null) {
        for (var j: number = 0; j < tagsToKeep.length; j++) {
          var tmpRegExp: RegExp = new RegExp(
            "</?" + tagsToKeep[j] + "( [^<>]*)*>",
            "i"
          );
          var tmpStr: string = foundedstrings[i] as string;
          if (tmpStr.search(tmpRegExp) != -1) tagFlag = true;
        }
      }
      if (!tagFlag) toBeRemoved.push(foundedstrings[i]);
    }
    for (i = 0; i < toBeRemoved.length; i++) {
      var tmpRE: RegExp = new RegExp("([+*$/])", "g");
      var tmpRemRE: RegExp = new RegExp(
        (toBeRemoved[i] as string).replace(tmpRE, "\\$1"),
        "g"
      );
      html = html.replace(tmpRemRE, "");
    }
    return html;
  }

  /**
   * 문자열에 포함된 특정 문자를 지정한 문자로 변경한다.
   * <pre>
   * remove("아/이/몬", ["/"])	=>	아이몬
   * remove("아&이@몬", ["&", "@"], "-")	=>	아-이-몬
   * </pre>
   * ※주의: split + join 으로 구현한 이 메서드는 성능이 그다지 좋지 않습니다.
   * @param s 원본문자열
   * @param chars 제거할 문자 또는 문자열의 배열
   * @return
   */
  static replaceAll(
    s: string,
    chars: Array<string>,
    repl: string = ""
  ): string {
    if (!chars || chars.length == 0 || !s) return s;

    chars.forEach((c) => {
      s = s.split(c).join(repl);
    });

    return s;
  }

  /**
   * 원본문자열에서 대부분의 파일시스템에서 파일명으로 사용 할 수 없는 문자를 제거해 반환한다.
   * @param s 원본문자열
   * @param repl 변경할 문자 (기본값 = "")
   * @return  파일 시스템에서 파일명으로 사용 할 수 없는 문자를 제거한 문자열
   */
  static stripFileSystemChars(s: string, repl: string = ""): string {
    return s.replace(/[~\\\/:\*\?"<>\|]/g, repl);
  }

  /**
   * 제공된 문자열에 동일주기로 증가/감소하는 문자가 특정회 존재하는지 여부를 반환
   * @param s 검사할 문자열
   * @param count 반복회수
   * @return 존재하면 True, 그렇지 않으면 False
   */
  static hasSerialChars(s: string, count: number): boolean {
    if (s == null || count <= 0) return false;

    var a: string[] = s.split("");
    var serial: number = 1;
    var gap: number;
    var prevGap: number;

    if (a.length <= count) return false;

    for (var i: number = 1; i < a.length; i++) {
      gap = a[i - 1].charCodeAt(0) - a[i].charCodeAt(0);
      serial = prevGap == gap ? serial + 1 : 1;
      if (serial == count - 1) return true;
      prevGap = gap;
    }

    return false;
  }

  /**
   * 제공된 문자열에 동일한 문자가 특정회 존재하는지 여부를 반환
   * @param s 검사할 문자열
   * @param count 반복회수
   * @return 존재하면 True, 그렇지 않으면 False
   */
  static hasSameChars(s: string, count: number): boolean {
    if (s == null || count <= 0) return false;

    var a: string[] = s.split("");
    var prev: string;
    var same: number = 1;

    if (a.length <= count) return false;

    for (var i: number = 0; i < a.length; i++) {
      if (prev != null) {
        same = prev == a[i] ? same + 1 : 1;
        if (same == count) return true;
      }

      prev = a[i];
    }

    return false;
  }

  /**
   * 전단일자의 문자열을 boolean 형으로 데이터형 변환후 반환하는 메소드
   * 단, 대소문자를 가리지 않으며, True 또는 False 문자열이 전달 되는경우에만
   * 정상 작동 그외 모든 문자 또는 Null인경우 False를 반환함.
   * <li> toboolean("TRUE" or "true") -> <b>return true</b>
   * <li> toboolean("FALSE" or "false" or "abcd" or "" or null) -> <b>return false</b>
   * @param s boolean형으로 변경할 문자열
   * @return boolean
   * */
  static toBoolean(s: string): boolean {
    if (this.isBlank(s)) return false;
    return s.toLowerCase() == "true";
  }

  /**
   * 전달인자의 문자열 current와 other를 전달받아<br>
   * 문자열 비교를 하여 동일한 문자열인지 판단후 True 또는 False를 반환하며,<br>
   * <b>문자열의 대소문자를 구분한다.</b><br>
   * <li> equal("AAA", "AAA") -> <b>Return True</b>
   * <li> equal("AAA", "AAa") -> <b>Return False</b>
   * <li> equal("AAA", "AA") -> <b>Return False</b>
   * <li> equal("", "AAA") -> <b>Return False</b>
   * <li> equal("AAA", "") -> <b>Return False</b>
   * <li> equal("", null) -> <b>Return False</b>
   * <li> equal(null, "") -> <b>Return False</b>
   * <li> equal("", "") -> <b>Return True</b>
   * <li> equal(null, null) -> <b>Return True</b>
   */
  static equal(current: string, other: string): boolean {
    if (this.isEmpty(current) && this.isEmpty(other)) return true;
    if (!this.isEmpty(current) && !this.isEmpty(other)) return current == other;
    return false;
  }

  /**
   * 전달인자의 문자열 current와 other를 전달받아<br>
   * 문자열 비교를 하여 동일한 문자열인지 판단후 True 또는 False를 반환하며,<br>
   * <b>문자열의 대소문자를 구분하지 않는다.</b><br>
   * <li> equal("AAA", "AAA") -> <b>Return True</b>
   * <li> equal("AAA", "AAa") -> <b>Return True</b>
   * <li> equal("AAA", "AA") -> <b>Return False</b>
   * <li> equal("", "AAA") -> <b>Return False</b>
   * <li> equal("AAA", "") -> <b>Return False</b>
   * <li> equal("", null) -> <b>Return False</b>
   * <li> equal(null, "") -> <b>Return False</b>
   * <li> equal("", "") -> <b>Return True</b>
   * <li> equal(null, null) -> <b>Return True</b>
   */
  static equalIgnoreCase(current: string, other: string): boolean {
    if (this.isEmpty(current) && this.isEmpty(other)) return true;
    if (!this.isEmpty(current) && !this.isEmpty(other))
      return current.toUpperCase() == other.toUpperCase();
    return false;
  }

  static trunc(text: string, length: number, tail: string = "..."): string {
    if (this.isBlank(text) || text.length <= length) return text;
    return text.substr(0, length) + (tail == null ? "" : tail);
  }

  static size(text: string): number {
    if (this.isBlank(text)) return 0;
    return text.length;
  }

  static parserBoolean(value: string): boolean {
    return this.equalIgnoreCase("true", value) || this.equalIgnoreCase("y", value);
  }

  /**
   *  JAVA String format과 동일한 기능을 하도록 구현한 함수
   *  index는 반드시 0부터 시작 해야함
   * 
   * notice) 중복된 값을 처리하지 못하는 문제가 있음.
   *  => Strings.format('{0},{0}', 'TEST') 일때 출력되는 값은 'TEST,{0} 임
   * 
   * @param str 
   * @param val 
   */
  static format(str: string, ...val: any[]) {
    for (let index = 0; index < val.length; index++) {
      str = str.replace(`{${index}}`, val[index]);
    }

    return str;
  }
}
